import { ReactNode } from 'react';
import { Flex, Box, BoxProps, FlexProps } from '@blockanalitica/ui';
import styled from 'styled-components';

const Wrapper = styled(Flex)<FlexProps>`
  line-height: normal;
  flex-direction: column;
`;

const Head = styled(Box)<BoxProps>`
  font-weight: 700;
  color: ${(props) => props.theme.colors.muted};
`;

export default function GlossaryLine({
  title,
  children
}: {
  title: string | ReactNode;
  children: ReactNode | ReactNode[];
}) {
  return (
    <Wrapper>
      <Head>{title}:</Head>
      <Box>{children}</Box>
    </Wrapper>
  );
}
